import React, { useState } from 'react';
import { userContext } from '../utils/user';
import { getUser } from '../utils/auth';
import AdminRoute from './admin-route';
import Prompt from '../pages/admin/prompt';

function AdminLayout() {
    const [user, setUser] = useState(getUser());
    const updateUser = user => {
        if (user) {
            localStorage.setItem('user', JSON.stringify(user));
            setUser(user);
        } else {
            setUser(false);
        }
    }

    return <userContext.Provider value={{ user: user, updateUser: updateUser }}>
        <div className='vh-100 d-flex flex-column'>
            <AdminRoute exact path='' component={Prompt} />
        </div>
    </userContext.Provider>
}

export default AdminLayout;